var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"label-standard"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"form-line"},[_c('input',{staticClass:"input-standard",attrs:{"type":"password"},domProps:{"value":_vm.value},on:{"blur":function($event){return _vm.updateValue({
        key       : _vm.propertyKey,
        value     : $event.target.value,
        objectType: _vm.objectType
      })}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }